
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import {RequestPaging} from "@/utils/util";
import {apiArticleCategoryLists, apiArticleCategoryDel, apiArticleCategoryIsShow, apiShopLists} from '@/api/shop'

@Component({
  components: {
    lsPagination
  }
})
export default class ArticleCategoryList extends Vue {
  pager: RequestPaging = new RequestPaging();
  searchObj: any = {};
  shopList: any[] = [];

  async getLists(): Promise<void> {
    this.pager.request({
      callback: apiArticleCategoryLists,
      params: this.searchObj
    });
  }

  resetSearch(): void {
    this.searchObj = {};
    this.getLists();
  }

  async getShopList(): Promise<void> {
    try {
      const res: any = await apiShopLists({
        page_no: 1,
        page_size: 9999
      });
      this.shopList = res.lists || [];
    } catch (error) {
      console.error('获取商户列表失败:', error);
      this.shopList = [];
    }
  }

  async onDelete(row: any): Promise<void> {
    await apiArticleCategoryDel({id: row.id});
    this.getLists();
  }

  async changeStatus(value: number, row: any): Promise<void> {
    try {
      await apiArticleCategoryIsShow({id: row.id});
    } catch (e) {
      row.is_show = row.is_show === 1 ? 0 : 1;
    }
  }

  created() {
    this.getShopList();
    this.getLists();
  }
}
